import { AnalyticsContextProvider } from "./AnalyticsContextProvider.tsx";

type SectionContextProps = {
  name: string;
  children: React.ReactNode | React.ReactNode[];
};

export const SectionContext = ({ name, ...props }: SectionContextProps) => {
  return <AnalyticsContextProvider properties={{ section: name }} {...props} />;
};
